export const companyInfo = {
    name: 'STAR INSURANCE SPECIALIST SRL',
    registrationCode: 'RAJ 502061',
    registrationUrl: 'https://asfromania.ro/app.php/ro/a/1704/intermediari-secundari',
    cui: '40722931',
    registruComert: 'J7/261/2019',
    address: {
        street: 'Str. Armeana nr. 50',
        postalCode: '710359',
        city: 'Botosani',
        county: 'Judetul Botosani',
    },
    partner: {
        name: 'RENOMIA INSURANCE REINSURANCE BROKER SRL',
        shortName: 'RENOMIA',
        url: 'https://www.renomia.ro/',
        logoPath: '/images/renomia-znacka-rgb.png',
    },
    contact: {
        emails: ['doina.tomuleanu@renomia.ro', 'gheorghe.tomuleanu@renomia.ro'],
        phones: ['0740.039.340', '0740.207.134'],
        workingHours: {
            days: 'Luni - Vineri',
            hours: '09:00 - 17:00',
        },
    },
    socialLinks: {
        googleReviews:
            'https://www.google.com/search?client=firefox-b-d&sa=X&sca_esv=1c5d2991ca1b4824&hl=ro-RO&tbm=lcl&sxsrf=ADLYWIICyUdW_nliCd8dw7t_l_jXhI4-AQ:1731569835160&q=RENOMIA%20SRBA%20-%20Partener%20Star%20Insurance%20Specialist%20Recenzii&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDE1MzYyNTc2MTG0tDQ0NTGxMNjAyPiK0SrI1c_f19NRITjIyVFBVyEgsagkNS-1SCG4JLFIwTOvuLQoMS85VSG4IDU5MzEns7hEISg1OTWvKjNzESsFmgGU1rm7lQAAAA&rldimm=14563257344199154480&ved=0CAcQ5foLahcKEwiIzYapqNuJAxUAAAAAHQAAAAAQCQ&biw=1920&bih=899&dpr=1#lkt=LocalPoiReviews&arid=ChZDSUhNMG9nS0VJQ0FnSUNKc2FtY1BREAE',
    },
};

export const features = [
    {
        id: 'consiliere',
        icon: 'MessageCircle',
        title: 'Consiliere Gratuita',
        description:
            'Va explicam toate optiunile disponibile si va ajutam sa intelegeti ce se potriveste cel mai bine nevoilor dumneavoastra.',
    },
    {
        id: 'rapiditate',
        icon: 'Zap',
        title: 'Rapiditate & Eficienta',
        description: 'Acces la oferte competitive si solutii personalizate, fara sa pierdeti timp.',
    },
    {
        id: 'transparenta',
        icon: 'Handshake',
        title: 'Transparenta Totala',
        description: 'Colaboram deschis, punand mereu interesele clientului pe primul loc.',
    },
];
